import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import styles from "./dashBoardStyles.module.css";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const LatestHits = () => {
  const dashBoarddata = useSelector((state) => state.dashboard.data);
    const latestHitsData = {
      data: {
        labels: dashBoarddata.latestHits.months,
        datasets: [
          {
            label: "Latest Hits",
            backgroundColor: "transparent",
            borderColor: "cyan",
            tension: 0.3,
            hoverBorderColor: "white",
            data: dashBoarddata.latestHits.latest,
          },
          {
            label: "Featured",
            backgroundColor: "transparent",
            borderColor: "#faff6f",
            tension: 0.3,
            hoverBorderColor: "white",
            data: dashBoarddata.latestHits.featured,
          },
          {
            label: "Popular",
            backgroundColor: "transparent",
            borderColor: "#a5ff3e",
            tension: 0.3,
            hoverBorderColor: "white",
            data: dashBoarddata.latestHits.popular,
          },
        ],
      },
    };
    return (
      <section className={styles.latestHitsSection}>
        <h1>latest hits</h1>
        <div style={{width:'80%',height:'80%'}}>
        <Line options={{ responsive: true, maintainAspectRatio:false,color:"white"}} data={latestHitsData.data} />
        </div>
      </section>
    );
};

export default LatestHits;
